import _objectSpread from "/root/ONLINE_SERVICE/other/ferry/task_workspace/baidu/map-ai-native/feed-h5/node_modules/.pnpm/@babel+runtime@7.23.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { setBuryArr } from '../bury';

// 屏幕高度
export default {
  props: {
    index: {
      type: Number,
      default: 0
    },
    dataItem: {
      type: Object,
      default: () => {
        return {};
      }
    },
    type: {
      type: String,
      default: ''
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.showHandle();
    });
  },
  methods: {
    showHandle() {
      const wHeight = window.innerHeight || window.outerHeight;
      const obDom = this.$refs.observeDom;
      if (!obDom) {
        return;
      }
      // 浏览结束的位置设置在距离顶部90px,浏览开始设置在距离顶部180px的位置
      let marginTop = this.type === 'top' ? 180 : 90;
      const bottomMargin = wHeight - marginTop || 400;
      // const rootMargin = `0px 0px -${bottomMargin}px 0px`;
      const rootMargin = '0px 0px $BOTTOM_MARGINpx 0px'.replace('$BOTTOM_MARGIN', -1 * bottomMargin);

      // 曝光埋点
      this.$io.observe(obDom, () => {
        // 需要从元素data属性获取到埋点参数信息
        const {
          unique_id = '',
          tpSource = '',
          levelOne = '',
          levelTwo = ''
        } = this.dataItem || {};
        let params = {
          end_unique_id: unique_id,
          endTime: Date.now(),
          tpSource,
          levelOne,
          levelTwo
        };
        if (this.type === 'top') {
          params = {
            start_unique_id: unique_id,
            startTime: Date.now()
          };
        }
        setBuryArr(_objectSpread({
          index: this.index
        }, params));
      }, {
        rootMargin
      });
    }
  }
};